var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "30px",
    viewBox: "0 0 39 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Card/Mastercard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 0,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ordering/Cart/L/VoucherApplied",
    transform: "translate(-167.000000, -362.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment",
    transform: "translate(35.000000, 336.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card/Mastercard",
    transform: "translate(132.210000, 26.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paypal",
    transform: "translate(13.151455, 4.860000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2279548,3.70422283 C11.4073127,2.5700505 11.2267201,1.798317 10.6081453,1.09931616 C9.92709561,0.329705056 8.69677782,0 7.12264273,0 L2.5533378,0 C2.23158011,0 1.9576457,0.232156766 1.90751768,0.547331616 L0.0048753113,12.5127109 C-0.0326589704,12.748786 0.151308397,12.9622494 0.392317996,12.9622494 L3.21315097,12.9622494 L3.01848303,14.1867049 C2.98564054,14.3932297 3.14656054,14.58 3.35744394,14.58 L5.73510899,14.58 C6.01653379,14.58 6.25614408,14.3769036 6.30001639,14.1012379 L6.32331069,13.9814045 L6.77125271,11.1645854 L6.80014423,11.0089163 C6.84393422,10.7332505 7.08354452,10.5301542 7.36496932,10.5301542 L7.72072188,10.5301542 C10.0241415,10.5301542 11.8277625,9.60201691 12.3548064,6.91801041 C12.574991,5.79640916 12.4611535,4.8602721 11.8787959,4.20216808 C11.7026482,4.00307161 11.4835336,3.83850479 11.2279548,3.70422283",
    id: "Fill-11",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6984625,3.57130931 C11.8853364,2.47783292 11.6971761,1.73379048 11.0526799,1.05987092 C10.3430908,0.317874704 9.06121654,0 7.42111727,0 L2.66033549,0 C2.32509454,0 2.0396809,0.223826605 1.98745226,0.527692471 L0.00507961136,12.0637346 C-0.0340275455,12.2913389 0.15764898,12.4971429 0.408758092,12.4971429 L3.34779815,12.4971429 L4.08611725,8.20099422 L4.06321898,8.33565221 C4.11544762,8.03186505 4.39845994,7.80803844 4.73361513,7.80803844 L6.13049533,7.80803844 C8.87391384,7.80803844 11.0220631,6.78523585 11.6497501,3.82716736 C11.6683603,3.73957277 11.6842262,3.65473273 11.6984625,3.57130931",
    id: "Fill-12",
    fill: "#283493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87923784,3.58586906 C4.91062648,3.40304585 5.03841083,3.25343461 5.21053377,3.17772392 C5.28874809,3.14333144 5.37613886,3.12420701 5.4678177,3.12420701 L9.19963529,3.12420701 C9.64173484,3.12420701 10.0539037,3.15072936 10.4308246,3.20644991 C10.5385408,3.22234758 10.6433412,3.24068499 10.7451398,3.26138345 C10.8469385,3.2821606 10.9457355,3.30529879 11.0414452,3.33103413 C11.0893,3.34378375 11.1362972,3.35724167 11.1826083,3.37132921 C11.3675954,3.42775807 11.5398899,3.4942607 11.6984625,3.57130931 C11.8853364,2.47783292 11.6971761,1.73379048 11.0526799,1.05987092 C10.3430908,0.317874704 9.06121654,0 7.42111727,0 L2.66033549,0 C2.32509454,0 2.0396809,0.223826605 1.98745226,0.527692471 L0.00507961136,12.0637346 C-0.0340275455,12.2913389 0.15764898,12.4971429 0.408758092,12.4971429 L3.34779815,12.4971429 L4.87923784,3.58586906",
    id: "Fill-13",
    fill: "#1464C1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.6aa55d7c.svg";
export { ForwardRef as ReactComponent };